import formComponent from '@/util/proto/formComponent'
import Review from './partial/review'

export default {
  extends: formComponent,
  data() {
    return {
      formData: {
        brand: {
          rules: [
            { required: true, message: '车辆品牌不能为空', trigger: 'blur,change' },
          ]
        },

        categoryId: {
          rules: [
            { type: 'number', required: true, message: '请选择车辆类型', trigger: 'blur,change' },
          ]
        },

        enrollDatetime: {
          rules: [
            { required: true, message: '请选择生产时间', trigger: 'blur,change' },
          ]
        },
        photo:{
          initialValue:[],
          rules:[
            { required: true, min:4 ,max:20, type:'array', message: '请选择图片,图片数量4-20张', trigger: 'blur,change' },
          ]
        },
        frameNo: {
          rules: [
            { required: true, message: '车架号不能为空', trigger: 'blur,change' },
          ]
        },
        electricity: {
          rules: [
            { type:"number", message: '', trigger: 'blur,change' },
          ]
        },
        voltage: {
          rules: [
            { type:"number", message: '', trigger: 'blur,change' },
          ]
        },
        batteryType:{
          rules: [
            { required: true,type:"number",  message: '请选择电池类型', trigger: 'blur,change' },
          ]
        },
        certNo:null,
        cocNo:null,
        motorNo: null,
        batteryNo:null,
        batterySpecs:null,
        batteryBrand:null,
        color:null,
        insuranceNo:null,
        // insuranceCompanyName:null,
        remark: null,
      },

      def: {},
      enableState: null,
      carNo: null,
      id: null,
      loading: false,
      visible: false,
      reviewable:false,
      recheck:false,//重审核
      api:['stdCarCreate','stdCarUpdate']
    }
  },

  computed: {
    itemTitle() {
      return this.id ? '编辑车辆' : '新增车辆'
    },
    cates(){
      return this.$request.common_carcate_used().then(resp => {
        return Promise.resolve(resp.data.map(i => ({
          value: i.id,
          label: i.name,
        })))
      })
    }
  },
  created() {

  },

  methods: {

    init(id , reviewable = false , recheck = false) {
      this.id = id
      this.reset()
      this.visible = true
      this.reviewable = reviewable
      this.recheck = recheck
      if (this.id) {
        this.query()
      }
    },

    query() {
      this.loading = true

      this.$request.stdCar(this.id).then(resp => {
        this.loading = false
        resp.data.photo = resp.data.photo ? resp.data.photo.split(';') : []

        this.$setFormData(resp.data)

        // console.log( this.form.getFieldValue('photo') )
      })
    },
    reset() {
      this.$resetFormData()
    },
    review(data){
      this.$dialog({
        title: '审核',
        width: 550,
        paddingless: true,
        render: (h) => {
          return <Review data={data} recheck={this.recheck} />
        },
        onOk: () => {
          this.$emit('update')
          this.visible = false
          //this.query()
        }
      })
    },
    
    beforeSave(d){
      const params = { ...d }
      if(Array.isArray(d.photo)){
        params.photo = d.photo.join(';')
      }
      if(this.id){
        params.id = this.id
      }

      if( this.reviewable ){
        this.review(params)
        return false
      }

      return params
    }
  },
  render() {
    const { itemTitle, formData, loading } = this

    return (
      <sl-side-panel v-model={this.visible} loading={loading} mask-closable={false} title={itemTitle}>
          <sl-form label-width={110}>
            <sl-form-item label="合格证编号">
              <Input v-decorator={formData.certNo}></Input>
            </sl-form-item>
            <sl-form-item label="一致性证书编号">
              <Input v-decorator={formData.cocNo}></Input>
            </sl-form-item>
            <sl-form-item label="车辆品牌">
              <Input v-decorator={formData.brand}></Input>
            </sl-form-item>
            <sl-form-item label="车辆类型">
              <sl-select dict={this.cates} v-decorator={formData.categoryId} />
            </sl-form-item>
            <sl-form-item label="车辆颜色">
              <Input v-decorator={formData.color}></Input>
            </sl-form-item>
            <sl-form-item label="电池类型">
              <sl-select type="radio" dict="batteryType" v-decorator={formData.batteryType} />
            </sl-form-item>
            <sl-form-item label="电池电压">
              <sl-select dict="$$voltage" v-decorator={formData.voltage}/>
            </sl-form-item>
            <sl-form-item label="电池电量">
              <sl-select dict="$$electricity" v-decorator={formData.electricity} />
            </sl-form-item>
            <sl-form-item label="电池序号">
              <Input v-decorator={formData.batteryNo}></Input>
            </sl-form-item>
            <sl-form-item label="电池规格">
              <Input v-decorator={formData.batterySpecs}></Input>
            </sl-form-item>
            <sl-form-item label="电池品牌">
              <Input v-decorator={formData.batteryBrand}></Input>
            </sl-form-item>
            <sl-form-item label="车架号">
              <Input v-decorator={formData.frameNo}></Input>
            </sl-form-item>
            <sl-form-item label="电机号">
              <Input v-decorator={formData.motorNo}></Input>
            </sl-form-item>
            <sl-form-item label="生产日期">
              <DatePicker type="date" v-decorator={formData.enrollDatetime}></DatePicker>
            </sl-form-item>
            <sl-form-item label="保单号">
              <Input v-decorator={formData.insuranceNo}></Input>
            </sl-form-item>
{/*            <sl-form-item label="保险公司">
              <Input v-decorator={formData.insuranceCompanyName}></Input>
            </sl-form-item>*/}
            <sl-form-item label="照片">
              <sl-upload public={true} style="margin-top:8px;" v-decorator={formData.photo} type="27" limit={20}>支持格式：jpg, png, bmp , gif。最少4张，最多20张。</sl-upload>
            </sl-form-item>
            <sl-form-item label="备注">
              <Input type="textarea" autosize={{minRows: 5,maxRows: 8}} v-decorator={formData.remark}></Input>
            </sl-form-item>
          </sl-form>
          <div slot="footer">
            <Button loading={loading} on-click={this.$handleSubmit} type="primary">{ this.reviewable ? '审核' : '确定' }</Button>
          </div>
      </sl-side-panel>
    )
  }
}
